import { http } from '../api/http';

export type WithdrawalStatus = 'PENDING' | 'APPROVED' | 'EXECUTED' | 'REJECTED';

export type AdminWithdrawal = {
  id: string | number;
  amount: string;
  currency: string;
  status: WithdrawalStatus;
  requested_at: string;
  approved_at?: string | null;
  executed_at?: string | null;
  reference?: string | null;
  user_comment?: string | null;
  notes?: string | null;
  user_id: string | number;
  user?: {
    id: string | number;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
  } | null;
  project?: {
    id: string;
    name: string;
    slug?: string | null;
    closedAt?: string | null;
  } | null;
  bankAccount?: {
    id: string | number;
    beneficiaryName?: string | null;
    bank?: { name: string | null; code: string | null } | null;
    clabe?: string | null;
    clabeMasked?: string | null;
  } | null;
  wallet?: {
    available: string;
    currency: string;
  } | null;
};

export const AdminWithdrawalsService = {
  list(status?: WithdrawalStatus) {
    const query = status ? `?status=${status}` : '';
    return http<AdminWithdrawal[]>(`/admin/withdrawals${query}`);
  },

  approve(id: string | number) {
    return http(`/admin/withdrawals/${id}/approve`, { method: 'PATCH' });
  },

  reject(id: string | number, notes?: string) {
    return http(`/admin/withdrawals/${id}/reject`, {
      method: 'PATCH',
      body: { notes }
    });
  },

  execute(id: string | number, payload: { reference: string; notes?: string }) {
    return http(`/admin/withdrawals/${id}/execute`, {
      method: 'PATCH',
      body: payload
    });
  }
};
